import React from 'react'
import { MyCard, AvaBlank, AvaBoy, AvaGirl, PICBlank } from '../../../Student/Profiles/components/ProfileUI';
import { StudentIDFormat } from '../../../../Library/GlobalHelper';

export function StdHeaders({ children, student }) {
    const student_data_rereg = student?.regstudent || ""
    const local_name_pp = `blob_pp_${student.candidate_id}`;
    const profile_pic = localStorage.getItem(local_name_pp) || "";

    return (
        <MyCard>
            <div className="py-6">
                <div className="d-flex flex-wrap flex-sm-nowrap">
                    <ProfilePicture student={student_data_rereg} profile_pic={profile_pic} />

                    <div className="flex-grow-1">
                        <div className="d-flex justify-content-between align-items-start flex-wrap mb-2 flex-wrap">
                            <InfoGeneral data={student_data_rereg} candidate_id={student?.candidate_id} />
                            <div>
                                <div className="badge badge-light px-6 py-3 h6 mr-2">
                                    {student?.status || "-"} Student
                                    ({student?.enrollment_type?.name || ""}
                                    {student?.transfer_type?.name
                                        ? ` - ${student.transfer_type.name}`
                                        : ""})
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center pe-8">
                            <div className="d-flex flex-wrap">
                                <BoxInfo
                                    title={student?.program_id === 1 ? "Bachelor's Degree":"Master's Degree"}
                                    value={student.target_department?.name || "-"}
                                />
                                <BoxInfo title={"Intake"} value={student?.term?.name} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {children}
        </MyCard>
    )
}


const ProfilePicture = ({ profile_pic, student }) => {
    return (
        <div className="mr-0">
            <div className="symbol symbol-150 symbol-light mr-4 symbol-fixed position-relative">
                {profile_pic ? (
                    <div
                        className="bg-light-primary p-1 h-150px w-150px rounded"
                        style={{
                            backgroundImage: profile_pic
                                ? `url(${profile_pic})`
                                : `url(${PICBlank})`,
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                        }}
                    ></div>
                ) : student.gender === "p" ? (
                    <AvaBoy className="bg-light-primary p-1" />
                ) : student.gender === "w" ? (
                    <AvaGirl className="bg-light-primary p-1" />
                ) : (
                    <AvaBlank className="bg-light-primary p-1" />
                )}
            </div>
        </div>
    );
};

const InfoGeneral = ({ candidate_id, data }) => {
    return (
        <div>
            <div className="d-flex align-items-center mb-2">
                <span className="text-gray-900 h1 font-weight-bold mr-1 text-capitalize">
                    {data?.fullname || "-"}
                </span>
                <i className={`fa fa-check h1 text-primary`}></i>
            </div>
            <div className="d-flex flex-wrap fw-semibold h6 pe-2">
                <LabelIcon icon={"flaticon2-user"} value={StudentIDFormat(candidate_id)} />
                <LabelIcon icon={"flaticon2-black-back-closed-envelope-shape"} value={data?.email || "-"} />
                <LabelIcon icon={"flaticon2-phone"} value={data?.mobile || "-"} />
            </div>
        </div>
    );
};

const LabelIcon = ({ icon, value }) => {
    return (
        <span className="d-flex align-items-center mr-5">
            <i className={`icon-1x text-gray-500 ${icon} mr-1`}></i>
            <span className="text-gray-500">{value}</span>
        </span>
    );
};

const BoxInfo = ({ title, value }) => {
    return (
        <div className="border border-dashed border-gray-300 rounded py-3 px-3 mb-3 min-w-80px mr-3">
            <div className="h4 fw-bolder text-gray-700 text-center">{value}</div>
            <span className="">{title}</span>
        </div>
    );
};
